// Incoming Email mock data (approved HTML:
// Incoming-Email-Consistency-Review-v5.html).
// Email and text cannot inherit the other channel's recipient, subject,
// draft, notes or request. Doug's world: Sarah emails about Duke's Gut
// X routine.

export const INCOMING_EMAIL = {
  heroEyebrow: 'CUSTOMER CONVERSATION',
  heroTitle: 'Incoming Email',
  heroContext: 'Confirm Duke’s daily routine · Assigned to Jamie Dorsey',
  purpose: 'Confirm Duke’s daily routine',
  reason: 'Sarah emailed asking for help checking Duke’s current Gut X routine.',
  recipient: 'Sarah Mitchell',
  destination: 'sarah.mitchell@example.com',
  subject: 'Re: Duke’s current Gut X routine',
  sender: 'Sarah Mitchell',
  sentAt: 'Sep 18, 2:14 PM Central',
  lastMessage:
    'Hi Jamie, we restarted Duke after his break. Can you confirm the current scoop size on Gut X?',
  draft:
    'Hi Sarah, happy to help. Duke was on 2 oz twice daily during his last subscription. I can resume that schedule or adjust if his routine has changed.',
  draftHint: 'Email to sarah.mitchell@example.com · Preference 2',
  channelLabel: 'Email message',
  threadLabel: 'LATEST EMAIL MESSAGE',
};
